// extracted by mini-css-extract-plugin
module.exports = {"transfer":"transfer_transfer_2vh1f"};